"use client";

const EmptyStateSearchResult = () => {
  return (
    <svg
      width="100"
      height="100"
      viewBox="0 0 160 160"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M79.3 129.7C107.3 129.7 130 107 130 78.9001C130 50.8001 107.2 28.1001 79.3 28.1001C51.3 28.1001 28.6 50.8001 28.6 78.9001C28.6 107 51.3 129.7 79.3 129.7Z"
        fill="#F5F5F5"
      />
      <path
        d={`M126.7 45.5999C128.964 45.5999 130.8 43.7643 130.8 41.4999C130.8 39.2355 128.964 37.3999 126.7 37.3999C124.436 37.3999 122.6 39.2355 122.6 41.4999C122.6
         43.7643 124.436 45.5999 126.7 45.5999Z`}
        fill="#F5F5F5"
      />
      <path
        d="M132.7 29.6C134.246 29.6 135.5 28.3464 135.5 26.8C135.5 25.2536 134.246 24 132.7 24C131.154 24 129.9 25.2536 129.9 26.8C129.9 28.3464 131.154 29.6 132.7 29.6Z"
        fill="#F5F5F5"
      />
      <path
        d="M31.3 45.4999C32.8464 45.4999 34.1 44.2463 34.1 42.6999C34.1 41.1535 32.8464 39.8999 31.3 39.8999C29.7536 39.8999 28.5 41.1535 28.5 42.6999C28.5 44.2463 29.7536 45.4999 31.3 45.4999Z"
        fill="#F5F5F5"
      />
      <path
        d="M14.2 99.5001C17.0719 99.5001 19.4 97.172 19.4 94.3001C19.4 91.4282 17.0719 89.1001 14.2 89.1001C11.3281 89.1001 9 91.4282 9 94.3001C9 97.172 11.3281 99.5001 14.2 99.5001Z"
        fill="#F5F5F5"
      />
      <g filter="url(#filter0_d_2583_49733)">
        <path
          d="M113.8 53.5L114.6 117.9C114.6 120.1 112.8 121.8 110.6 121.8H47.8C45.6 121.8 43.8 120 43.8 117.9V35.0999C43.8 32.8999 45.6 31.2 47.8 31.2H93.3001L113.8 53.5Z"
          fill="white"
        />
      </g>
      <path
        d="M74.4 108.9H72.1C71.6 108.9 71.2 108.4 71.2 107.8C71.2 107.2 71.6 106.7 72.1 106.7H74.4C74.9 106.7 75.3 107.2 75.3 107.8C75.3 108.5 74.9 108.9 74.4 108.9Z"
        fill="#F5F5F5"
      />
      <path
        d="M67.4 108.9H54C53.5 108.9 53.1 108.4 53.1 107.8C53.1 107.2 53.5 106.7 54 106.7H67.4C67.9 106.7 68.3 107.2 68.3 107.8C68.3 108.5 67.9 108.9 67.4 108.9Z"
        fill="#BFBFBF"
      />
      <path
        d="M84.5 44.7001H54.4C53.7 44.7001 53.1 44.1001 53.1 43.4001C53.1 42.7001 53.7 42.1001 54.4 42.1001H84.5C85.2 42.1001 85.8 42.7001 85.8 43.4001C85.8 44.1001 85.2 44.7001 84.5 44.7001Z"
        fill="#BFBFBF"
      />
      <path
        d="M66 51.9001H54.4C53.7 51.9001 53.1 51.3 53.1 50.6C53.1 49.9 53.7 49.3 54.4 49.3H65.9C66.6 49.3 67.2 49.9 67.2 50.6C67.2 51.3 66.6 51.9001 66 51.9001Z"
        fill="#BFBFBF"
      />
      <path
        d="M93.3 31.2V49C93.3 51.5 95.5 53.5 98 53.5H113.8"
        fill="#BFBFBF"
      />
      <path
        d={`M118.6 123.3C117.6 123.3 116.6 122.9 115.8 122L99.1 105.3L98.5 105.7C93.1 109.7 86.8 111.8 80.4 111.8C72.7 111.8 65 108.7 59.3 103.3C53.3 97.6 50 89.8999 
        50 81.5C50 64.7999 63.6 51.2 80.3 51.2C91.7 51.2 101.7 57.2 107.1 67.4C112.4 77.5 111.7 89.3 105.2 98.8L104.8 99.4L121.6 116.2C123.3 117.9 122.9 119.6 122.6 
        120.5C121.8 122.1 120.2 123.3 118.6 123.3ZM80.3 59.5C68.1 59.5 58.3 69.4
         58.3 81.5C58.3 95.2999 69.6 103.6 80.6 103.6C87.3 103.6 93.4 100.6 97.7 95.1998C103 88.5998 103.9 79.7 100.2 72C96.4 64.3 88.8 59.5 80.3 59.5Z`}
        fill="#8C8C8C"
      />
      <path
        d="M70.8 85.1C72.1 85.1 73.2 84.0001 73.2 82.7001C73.2 81.4001 72.1 80.3 70.8 80.3C69.5 80.3 68.4 81.4001 68.4 82.7001C68.4 84.0001 69.5 85.1 70.8 85.1Z"
        fill="#8C8C8C"
      />
      <path
        d="M89.2 85.1C90.5 85.1 91.6 84.0001 91.6 82.7001C91.6 81.4001 90.5 80.3 89.2 80.3C87.9 80.3 86.8 81.4001 86.8 82.7001C86.8 84.1001 87.9 85.1 89.2 85.1Z"
        fill="#8C8C8C"
      />
      <path
        d="M70.7062 74.7598L65.4268 77.6104L66.1394 78.9302L71.4188 76.0796L70.7062 74.7598Z"
        fill="#8C8C8C"
      />
      <path
        d="M88.8736 74.7219L88.1611 76.0419L93.4411 78.8919L94.1536 77.5719L88.8736 74.7219Z"
        fill="#8C8C8C"
      />
      <path
        d="M80 90.7C81.5464 90.7 82.8 89.7598 82.8 88.6C82.8 87.4402 81.5464 86.5 80 86.5C78.4536 86.5 77.2 87.4402 77.2 88.6C77.2 89.7598 78.4536 90.7 80 90.7Z"
        fill="#8C8C8C"
      />
      <defs>
        <filter
          id="filter0_d_2583_49733"
          x="31.8"
          y="22.2"
          width="94.8"
          height="114.6"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="3" />
          <feGaussianBlur stdDeviation="6" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_2583_49733"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_2583_49733"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
};

export default EmptyStateSearchResult;
